(function($) {
  /**
	 * AJAX Popup
	 * @since 2019-04-22
	 */
	$(document).on('click', '.js-ajax-popup', event => {
		event.preventDefault();
		$.magnificPopup.open({
			type: 'ajax',
			mainClass: 'component-popup mfp-slide-up',
			removalDelay: 200
		});
	});

	/**
	 * Inlnie Popup
	 * @since 2019-04-25
	 */
	$(document).on('click', '.js-inline-popup', function(event) {
		event.preventDefault();
		var src = this.hash || this.dataset.target;
		$.magnificPopup.open({
			type: 'inline',
			items: {
				src: src
			},
			mainClass: 'component-popup mfp-slide-up',
			removalDelay: 200,
                        callbacks: {
                            open: function() {
                                if (typeof window.Swiper === 'function') {
                                    var slide = this.content.find('.swiper-container').get(0);
                                    if (slide && slide.hasOwnProperty('swiper')) {
                                        slide.swiper.update();
                                    }
                                }
                            }
                        },
		});
	})
})(jQuery);